import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { globalContactUsModalToggled } from '../actions';

const useContactUsToggler = () => {
  const dispatch = useDispatch();
  const globalContactUsModalVisible = useSelector(({
    common,
  }) => common.globalContactUsModalVisible);

  const onContactUsToggle = useCallback(() => {
    dispatch(globalContactUsModalToggled());
  }, [dispatch]);

  return {
    globalContactUsModalVisible,
    onContactUsToggle,
  };
};

export { useContactUsToggler };
